import FieldAutocomplete from './FieldAutocomplete';
import FieldAutocompleteMultiple from './FieldAutocompleteMultiple';
import FieldDate from './FieldDate';
import FieldSwitch from './FieldSwitch';
import FieldText from './FieldText';
import FieldTime from './FieldTime';
import FieldTextArea from './FieldTextArea';
import FieldTextDrilldown from './FieldTextDrilldown';
import List from './List';
import PageHeader from './PageHeader';
import FilterDate from './FilterDate';
import LabelText from './LabelText';
import FieldStaticValue from './FieldStaticValue';
import ButtonShowMoreInfo from './ButtonShowMoreInfo';
import DetailFormPopup from './DetailFormPopup';
import PageList from './PageList';
import PageDetail from './PageDetail';
import PageDetailTabs from './PageDetailTabs';
import ListTab from './ListTab';
import DetailForm from './DetailForm';
import FieldCurrency from './FieldCurrency';
import FieldTextJoin from './FieldTextJoin';
import FieldTextJoinAutocomplete from './FieldTextJoinAutocomplete';
import FieldWebLink from './FieldWebLink';
import FieldAutocompleteCountry from './FieldAutocompleteCountry';
import FieldAutocompleteCountryPhoneCode from './FieldAutocompleteCountryPhoneCode';
import FieldSwitchJoin from './FieldSwitchJoin';
import FieldBarcode from './FieldBarcode';
import FilterText from './FilterText';
import ImageTab from './ImageTab';
import FieldTextAreaJoin from './FieldTextAreaJoin';
import FieldVideo from './FieldVideo';
import AttachmentUploadPopup from './AttachmentUploadPopup';

const COMPONENT_MAP = {
  DetailFormPopup,
  ButtonShowMoreInfo,
  DetailForm,
  FieldAutocomplete,
  FieldAutocompleteMultiple,
  FieldDate,
  FieldStaticValue,
  FieldSwitch,
  FieldText,
  FieldTextArea,
  FieldTextDrilldown,
  FieldTime,
  FilterDate,
  LabelText,
  List,
  ListTab,
  PageDetail,
  PageDetailTabs,
  PageHeader,
  PageList,
  FieldCurrency,
  FieldTextJoin,
  FieldTextJoinAutocomplete,
  FieldWebLink,
  FieldAutocompleteCountry,
  FieldAutocompleteCountryPhoneCode,
  FieldSwitchJoin,
  FieldBarcode,
  FilterText,
  ImageTab,
  FieldTextAreaJoin,
  FieldVideo,
  AttachmentUploadPopup,
};

export default COMPONENT_MAP;